











































































import { Component, Vue } from 'vue-property-decorator'
import { AuthenticationToken, Credentials } from '@/models'

import { ActionTypes } from '@/store/action-types'
import { MutationTypes } from '@/store/mutation-types'
import ApiGtag, { Category } from '@/services/api-gtag'

@Component({
  components: {
    Footer: () => import('@/containers/Footer.vue'),
    Message: () => import('@/containers/Message.vue')
  }
})

export default class Login extends Vue {
  private username = ''
  private password = ''

  private auth_url = `${process.env.VUE_APP_KLDX_API_URL}/auth/aws/login`

  async login() {
    const {
      username,
      password
    } = this
    if (!username || !password) return
    const credentials: Credentials = {
      username,
      password
    }
    this.$store.dispatch(ActionTypes.AUTH_LOGIN, credentials)
  }

  public hasAccessToken() {
    const hash = this.$route.hash.substring(1)
    const tokenParams = new URLSearchParams(hash)
    const authTokenT = tokenParams.get('access_token')
    const tokenTypeT = tokenParams.get('token_type')
    const expiresInT = tokenParams.get('expires_in')
    if (authTokenT) {
      const authToken: AuthenticationToken = {
        accessToken: authTokenT,
        tokenType: tokenTypeT || 'Bearer',
        expiresIn: Number(expiresInT) || 3600
      }
      this.$store.commit(MutationTypes.SET_TOKEN, authToken)
      this.$store.commit(MutationTypes.SET_LOADING, false)
      this.$router.push('/')
    }
  }

  private sendLoginEvent(btn: string) {
    ApiGtag.sendEvent(Category.User, 'Login Method', btn)
  }

  created() {
    this.hasAccessToken()
    window.document.title = `${this.$i18n.t('pageTitle.home')} - LDX`
  }
}
